/* eslint-disable max-len */
import axios from "axios";
import { useMemo, useState, useContext, useRef, useEffect } from "react";
import { useScreenClass } from "react-grid-system";
import { useNavigate } from "react-router-dom";
import AllCompetenciesList from "../../components/AllCompetenciesList";
import SearchCompetencies from "../../components/SearchCompetencies";
import { UserContext } from "../../context/UserContext";
import { VersionContext } from "../../context/VersionContext";
import LoadingSpinner from "../../components/LoadingSpinner";

function ViewCompetencies() {
  const navigate = useNavigate();
  const userContext = useContext(UserContext);
  const role = userContext.user.role;
  const roleId = userContext.user.id;

  const redirectExplore = () => {
    navigate("/view/pillars");
  };
  const screenClass = useScreenClass();
  const isMobile = useMemo(
    () => ["xs", "sm"].includes(screenClass),
    [screenClass]
  );
  const [snackbarOpen, setSnackbarOpen] = useState<boolean>(false);
  const [searchResult, setSearchResult] = useState<any>("");
  const [competencies, setCompetencies] = useState<Array<any>>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const { version } = useContext(VersionContext);
  const universityCode = localStorage.getItem("university");
  const [defaultSearchText, setDefaultSearchText] = useState<any>("");
  const [totalRequiredCredits, setTotalRequiredCredits] = useState<
    number | null
  >(null);
  const [optionGroupCredits, setOptionGroupCredits] = useState<any>(null);
  const [totalCredits, setTotalCredits] = useState<any>(null);
  const ref = useRef(null);
  const redirectToPillar = () => {
    navigate("/view/pillars");
  };
  const currentPillar: any = localStorage.getItem("currentPillar");

  const searchCompetency = (keyword: string) => {
    localStorage.setItem("currentPillar", keyword);
    const found = filterArrayElementByCode(keyword);
    // if (found && found.id) {
    //   setSearchResult(found.id);
    // } else {
    //   setSnackbarOpen(true);
    //   setSearchResult("");
    // }
  };
  useEffect(() => {
    if (version.version_number === 0) {
      navigate("/curriculum/version");
    }
    fetchCompetencies();
  }, []);
  useEffect(() => {
    scrollTo(ref);
    if (currentPillar) {
      setDefaultSearchText(currentPillar);
      searchCompetency(currentPillar);
    }
  }, [ref, competencies]);
  const fetchCompetencies = () => {
    setLoading(true);
    axios
      .get(
        `/competency/summary?university_code=${universityCode}&curriculum_version=${
          version.version_number
        }${role === "instructor" ? `&instructor_id=${roleId}` : ""}`
      )
      .then((res) => {
        if (res.data.competencies) {
          setCompetencies(res.data.competencies);
        }
        setLoading(false);
      })
      .catch(() => {
        setCompetencies([]);
        setLoading(false);
      });
  };
  function filterArrayElementByCode(code: string) {
    const result = competencies.filter((item: any) =>
      item.competency_code.toLowerCase().includes(code.toLowerCase())
    );
    if (code.length === 3 && result?.length > 0) {
      const totalCount = result.reduce((accumulator, currentValue) => {
        return accumulator + currentValue.credits;
      }, 0);

      const requiredCount = result.reduce((accumulator, currentValue) => {
        return currentValue.required
          ? accumulator + currentValue.credits
          : accumulator;
      }, 0);
      const modified = Array.from(
        result
          .reduce((map, item) => {
            if (item.option_group !== null) {
              map.set(item.option_group.option_group_id, item);
            }
            return map;
          }, new Map())
          .values()
      );
      const optinGroupCredits = modified?.reduce(
        (accumulator: any, currentValue: any) => {
          return currentValue?.option_group
            ? accumulator + currentValue?.option_group?.option_group_credit
            : accumulator;
        },
        0
      );

      setTotalCredits(totalCount);
      setOptionGroupCredits(optinGroupCredits || 0);
      setTotalRequiredCredits(requiredCount);
    } else {
      setTotalCredits(null);
      setOptionGroupCredits(null);
      setTotalRequiredCredits(null);
    }
    setSearchResult(result);
    return result;
    // return competencies.filter((element) => {
    //   return element.competency_code === code;
    // })[0];
  }
  const scrollTo = (ref: any) => {
    if (ref && ref.current /* + other conditions */) {
      ref.current.scrollIntoView({ block: "start", behavior: "smooth" });
    }
  };
  return (
    <>
      <SearchCompetencies
        totalCredits={totalCredits}
        totalRequiredCredits={totalRequiredCredits}
        optionGroupCredits={optionGroupCredits}
        defaultSearchText={defaultSearchText}
        mode="view"
        onSearch={(keyword) => searchCompetency(keyword)}
        snackbarOpen={snackbarOpen}
        setSnackbarOpen={setSnackbarOpen}
      >
        {loading ? <LoadingSpinner />:
        <AllCompetenciesList
          navHeight={totalCredits ? "190px" : "0px"}
          mode="view"
          fetchParent={fetchCompetencies}
          data={searchResult ? searchResult : competencies}
          searchId={searchResult}
          onSelect={(data: any) => {
            navigate(`/modify/competency/${data.competency_code}`);
          }}
        />}
      </SearchCompetencies>
    </>
  );
}
export default ViewCompetencies;
